import { render, staticRenderFns } from "./generalView.vue?vue&type=template&id=f837683e&scoped=true"
import script from "./generalView.vue?vue&type=script&lang=js"
export * from "./generalView.vue?vue&type=script&lang=js"
import style0 from "./generalView.vue?vue&type=style&index=0&id=f837683e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f837683e",
  null
  
)

export default component.exports